module.exports = __webpack_public_path__ + "img/zh-Hant.f6609864.svg";